import { Navigate } from "react-router-dom";
const Testimonials = () => <Navigate to="/#testimonials" replace />;
export default Testimonials;
